import axios from "axios";
import { buildP2PStats } from "./stats";
import { ALLOWED_FIATS, ALLOWED_SIDES, DEFAULT_P2P_LIMIT } from "./types";
import { formatRequestError } from "./errors";

const BITGET_ENDPOINT = "/api/bitget-p2p/v1/p2p/adv/search";

/**
 * @param {Object} options
 * @param {"BRL"|"BOB"} options.fiat
 * @param {"BUY"|"SELL"} options.side
 * @param {number} [options.pageNo]
 * @param {number} [options.pageSize]
 * @returns {Promise<import("./types").P2PQuote>}
 */
/**
 * Esses providers podem devolver 403 no browser sem um proxy backend em produção.
 */
export async function fetchBitgetP2P({
  fiat,
  side,
  pageNo = 1,
  pageSize = DEFAULT_P2P_LIMIT,
}) {
  const normalizedFiat = String(fiat || "").toUpperCase();
  if (!ALLOWED_FIATS.includes(normalizedFiat)) {
    throw new Error("Fiat inválido para Bitget P2P");
  }
  const normalizedSide = String(side || "").toUpperCase();
  if (!ALLOWED_SIDES.includes(normalizedSide)) {
    throw new Error("Side inválido para Bitget P2P");
  }

  const payload = {
    coin: "USDT",
    fiat: normalizedFiat,
    side: normalizedSide,
    pageNo,
    pageSize,
    payMethod: [],
  };
  let response;
  try {
    response = await axios.post(BITGET_ENDPOINT, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    throw new Error(
      formatRequestError({
        exchange: "bitget",
        fiat: normalizedFiat,
        side: normalizedSide,
        fallback: "Indisponível",
        error,
      })
    );
  }
  const listing = Array.isArray(response.data?.data?.list)
    ? response.data.data.list
    : [];
  const prices = listing
    .map((item) => Number(item?.price))
    .filter((price) => Number.isFinite(price));
  if (!prices.length) {
    throw new Error("Não foi possível obter anúncios válidos da Bitget");
  }
  return buildP2PStats({
    exchange: "bitget",
    fiat: normalizedFiat,
    side: normalizedSide,
    prices,
    raw: import.meta.env.MODE === "development" ? listing : undefined,
  });
}
